import { observer } from 'mobx-react-lite'
import React from 'react'

import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'

import { Dialog, useGlobalCopyStore } from '../../../../common'

interface ActionProps {
  handleClose: () => void
  handleVerify: (token: string) => void
  isOpen: boolean
}

const VerifyTokenAction: React.FC<ActionProps> = observer(
  ({ handleClose, handleVerify, isOpen }) => {
    const { common: commonCopy, settings: settingsCopy } = useGlobalCopyStore()
    const [token, setToken] = React.useState('')

    return (
      <Dialog
        copy={{ title: settingsCopy.enter_verification_code }}
        isOpen={isOpen}
        onClose={handleClose}
        onPrimaryAction={() => handleVerify(token)}
        onSecondaryAction={handleClose}
        primaryText={settingsCopy.verify}
        secondaryText={commonCopy.cancel_button}
        sx={{
          '& .MuiDialogContent-root': { pt: 0, width: 400 },
          '& .MuiToolbar-root:last-child': {
            gap: 8,
            padding: 24,
            justifyContent: 'flex-end',
          },
        }}
      >
        <Stack>
          <TextField onChange={(e) => setToken(e.target.value)} sx={{ width: 352 }} value={token} />
        </Stack>
      </Dialog>
    )
  },
)

export default VerifyTokenAction
